import { createSelector } from "@reduxjs/toolkit";
import * as fromOfferFilters from "./offerFilterReducer";

//utils

const _getOfferFilter = (state) => fromOfferFilters.getOfferFilter(state.offerFilters);

// Selects the state managed by Redux-ORM.
export const ormSelector = (state) => state.orm;

// Redux-ORM selectors work with @reduxjs/toolkit. To feed input
// selectors to a Redux-ORM selector, we use the @reduxjs/toolkit `createSelector`.

// returns the "selectedCategory" parent category
export const selectedCategories = createSelector(
  [ormSelector, _getOfferFilter],
  (orm, offerFilter) => {
    const selectedCategoryId = offerFilter.selectedCategory.id;
    return orm.Category.withId(selectedCategoryId).ref;
  },
);

// returns all parent categories
export const rootCategories = createSelector([ormSelector], (orm) => {
  const filtered = getCategoriesList(orm.OrmCategory.itemsById, "root");
  return returnFilteredCategoriesList(filtered);
});

// returns all subcategories
export const subCategories = createSelector([ormSelector], (orm) => {
  const filtered = getCategoriesList(orm.OrmCategory.itemsById, "sub");
  return returnFilteredCategoriesList(filtered);
});

// returns subcategories for the "selectedCategory" parent category
export const categoriesSelector = createSelector(
  [ormSelector, _getOfferFilter],
  (orm, offerFilter) => {
    return getSubCategories(offerFilter.selectedCategory.id, orm.OrmCategory.itemsById);
  },
);

// returns subcategories for the "selectedCategoryTemp" parent category
export const tempSubcategoriesSelector = createSelector(
  [ormSelector, _getOfferFilter],
  (orm, offerFilter) => {
    if (!offerFilter.selectedCategoryTemp) return [];
    return getSubCategories(offerFilter.selectedCategoryTemp.id, orm.OrmCategory.itemsById);
  },
);

const getCategoriesList = (itemsById, matchedItems) => {
  return Object.keys(itemsById)
    .filter((key) => {
      if (matchedItems === "root") {
        return itemsById[key].parentCategory === 0;
      } else if (matchedItems === "sub") {
        return itemsById[key].parentCategory !== 0;
      } else {
        return itemsById[key].parentCategory === matchedItems;
      }
    })
    .reduce((res, key) => Object.assign(res, { [key]: itemsById[key] }), {});
};

const returnFilteredCategoriesList = (filteredList) => {
  return Object.keys(filteredList)
    .map((key) => filteredList[key])
    .sort((a, b) => a.name.localeCompare(b.name));
};

const getSubCategories = (selectedCategoryId, itemsById) => {
  const filtered = getCategoriesList(itemsById, selectedCategoryId);
  return returnFilteredCategoriesList(filtered);
};
